// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1aW0b","requiredAsterisk":"Info_requiredAsterisk__4FQFW"};